module.exports = __webpack_public_path__ + "img/gravier_quartz.8b37d1a7.jpg";